import { TrainingStep } from "../../components/common/TrainingGuide";

const inventorySteps: TrainingStep[] = [
  {
    title: "Inventory Overview",
    description:
      "The inventory module connects to Shopify via the Admin API and shows real-time stock levels for ENZO Italy and Lizze Professional products. Data is Redis-cached with a 10-minute TTL.",
    tip: "If stock looks outdated, click 'Refresh' to bust the cache and pull fresh data.",
  },
  {
    title: "Reading Stock Levels",
    description:
      "Each product card shows current inventory quantity, the SKU, price (AED), and a colour-coded bar: green = healthy, amber = low, red = critical (below reorder threshold).",
    tip: "Focus on red items first thing each morning — these can block sales.",
  },
  {
    title: "Low Stock Alerts",
    description:
      "When a product drops below its reorder threshold (configurable per SKU), an alert card appears at the top of the dashboard. These are also visible on the main AFAQ OS Dashboard overview.",
    tip: "Set realistic thresholds — a product that sells 5 units/day needs a higher threshold than one that sells 5/month.",
  },
  {
    title: "Reorder Workflow",
    description:
      "Click any low-stock item to open its detail view. From there you can export a reorder request (PDF/CSV) to send to your supplier. ENZO reorders go through the Italian distributor portal.",
    tip: "For Lizze, you are the brand owner — place production orders directly with the factory.",
  },
  {
    title: "Connecting to Shopify",
    description:
      "The Shopify integration uses the SHOPIFY_ACCESS_TOKEN in .env. If inventory shows empty or 'Connection failed', check that the token hasn't expired and the Shopify store URL is correct in config.py.",
    tip: "Shopify rate limits apply. The Redis cache prevents hitting limits — do not disable it.",
  },
];

export default inventorySteps;
